/**
 * 联营管理模块翻译 - 中文
 * 包含：联营合同、结算单
 */
export default {
  joint: {
    contract: {
      title: '联营合同管理',
      // 搜索
      keyword: '关键字',
      keywordPlaceholder: '合同号/商户名/铺位',
      contractNo: '合同编号',
      contractStatus: '合同状态',
      contractType: '合同类型',
      merchantName: '商户名称',
      merchant: '商户',
      allMerchants: '全部商户',
      shopName: '铺位',
      brandName: '品牌',
      settlementMode: '结算模式',
      contractPeriod: '合同期限',
      manualContractNo: '手工合同号',
      leaseArea: '租赁面积',
      createTime: '创建时间',
      operation: '操作',
      periodTo: '至',
      unitYuan: '元',
      unitSqm: '㎡',
      unitPercent: '%',

      // 状态
      statusDraft: '草稿',
      statusPending: '审批中',
      statusEffective: '生效中',
      statusExpired: '已过期',
      statusTerminated: '已终止',

      // 合同类型
      typeNew: '新签',
      typeRenew: '续签',
      typeChange: '变更',

      // 结算模式
      modeCommission: '纯扣率',
      modeSalesGuarantee: '销售保底',
      modeGrossProfit: '毛利保底',

      // 操作按钮
      addContract: '新建合同',
      backToList: '返回列表',
      search: '搜索',
      reset: '重置',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      confirm: '确定',
      approve: '审批',
      submitApproval: '提交审批',
      withdrawApproval: '撤回审批',
      renew: '续签',
      change: '变更',
      terminate: '终止',
      print: '打印合同',

      // Tab
      tabBasic: '基本信息',
      tabSettlement: '结算标准',
      tabFee: '收费信息',
      tabTerms: '合同约定',
      tabTermsSection: '合同约定',
      tabProduct: '商品绑定',
      addProductBinding: '添加商品绑定',

      // 新建/编辑页
      addTitle: '新增联营合同',
      editTitle: '编辑联营合同',
      detailTitle: '联营合同详情',
      renewTitle: '续签联营合同',
      changeTitle: '变更联营合同',

      // 基本信息 - 合同基础
      sectionContractBase: '合同基础',
      signingDept: '签约部门',
      recruiter: '招商人员',
      signDate: '签订日期',
      signingDeptPlaceholder: '请选择部门',
      deptRecruitment: '招商部',
      deptOperation: '营运部',
      deptMarketing: '市场部',

      // 基本信息 - 商户信息
      sectionMerchantInfo: '商户信息',
      businessType: '经营业态',
      salesDept: '销售部门',
      category: '经营分类',
      categoryPlaceholder: '请先选择业态再选择分类',
      businessTypeRetail: '零售',
      businessTypeCatering: '餐饮',
      businessTypeEntertainment: '娱乐',
      businessTypeService: '服务',
      merchantRequired: '请选择商户',
      merchantPlaceholder: '请选择商户',
      signingDeptRequired: '请选择签约部门',
      recruiterRequired: '请选择招商人员',
      businessTypeRequired: '请选择经营业态',
      categoryRequired: '请选择经营分类',
      salesDeptRequired: '请选择销售部门',
      brandRequired: '请选择经营品牌',
      signCompanyRequired: '请选择收费主体',
      signDateRequired: '请选择签订日期',

      // 基本信息 - 品牌
      brandLabel: '经营品牌',
      addBrand: '+ 添加品牌',
      clickToSetMainBrand: '点击品牌名称设置为主品牌',
      mainBrand: '主品牌',

      // 基本信息 - 铺位
      sectionShopInfo: '铺位信息',
      selectShop: '选择铺位',
      addShop: '+ 添加铺位',
      selectedShops: '已选铺位',
      totalArea: '总面积',
      selectedShopsCount: '{count} 间',
      shopRequired: '请选择铺位',

      // 基本信息 - 收费主体
      signCompany: '收费主体',
      addCompany: '+ 添加公司',

      // 基本信息 - 合同期限
      sectionContractPeriod: '合同期限',
      startDate: '合同开始日期',
      endDate: '合同结束日期',
      decorationStartDate: '装修开始日期',
      decorationEndDate: '装修结束日期',
      openingDate: '开业日期',
      startDateRequired: '请选择开始日期',
      endDateRequired: '请选择结束日期',

      // 结算标准
      settlementModeLabel: '结算模式',
      defaultRate: '默认扣率',
      periodBreakdown: '结算区段',
      settlementPeriod: '结算区段',
      mainRate: '主扣率(%)',
      rateColumn: '扣率(%)',
      tierCount: '保底档数',
      guaranteeTierSales: '保底销售{n}',
      guaranteeTierRate: '扣率{n}(%',
      guaranteeTierGrossProfit: '保底毛利{n}',
      tierAmountStart: '销售金额起',
      tierAmountEnd: '销售金额止',
      autoSplitYearly: '按年度自动分解',
      splitGuaranteeAmount: '分解保底金额',
      addPeriod: '添加时间段',
      monthlyGuaranteeSales: '月保底销售',
      guaranteeRate: '保底扣率(%)',
      presetMonthlyGrossProfit: '预设月保底毛利',
      actualMonthlyGrossProfit: '实际月保底毛利',
      totalGuarantee: '总保底',
      totalGrossProfit: '总毛利',
      periodLabel: '时间段',
      monthlyBreakdown: '月度分解明细',
      yearMonthLabel: '年月',
      guaranteedSales: '保底销售',
      guaranteedGrossProfit: '保底毛利',
      periodSettled: '区间清算',
      cumulativeSettled: '累计清算',
      rateSettings: '扣率设置',
      addRate: '添加扣率',
      saveRates: '保存扣率',
      allStages: '全部阶段',
      rateNamePlaceholder: '如：扣率1-主品牌',
      tierAmountPlaceholder: '如：≤50万',
      allAmount: '全额',
      ratePercent: '扣率%',
      yearStage: '第{n}年 ({start}~{end})',
      annualTotal: '合计',
      actualSales: '实际销售',

      // 收费信息
      sectionPaymentFee: '手续费',
      sectionDeposit: '保证金',
      depositHint: '（复用现有保证金体系）',
      depositType: '保证金类型',
      feeName: '费用项目',
      amount: '金额',
      receivedStatus: '收款状态',
      received: '已收',
      notReceived: '未收',
      viewFlow: '查看流水',
      addDeposit: '新增保证金',
      goToDeposit: '前往保证金管理，自动关联当前合同',
      sectionFeeItem: '费用项目',
      addFeeItem: '新增费用',
      feeItemHint: '按月/季/年收取的固定费用，如：推广费、运营管理费、POS使用费等',
      chargeMethod: '收费方式',
      chargePeriod: '收费周期',
      startMonth: '起始月份',
      endMonth: '结束月份',
      fixedAmount: '固定金额',
      salesRatioAmount: '销售比例',
      sqmMonthly: '元/㎡/月',
      monthlyFixed: '月固定',
      dailyFixed: '日固定',
      oneTimeFixed: '一次性',
      monthlyPeriod: '按月收取',
      quarterlyPeriod: '按季收取',
      yearlyPeriod: '按年收取',
      oneTimePeriod: '一次性收取',
      feeBearer: '手续费承担方',
      feeBearerMerchant: '商户承担',
      feeBearerMall: '商场承担',
      feeHint: '从商户结算款中扣除的支付手续费',
      addPaymentMethod: '添加支付方式',
      savePaymentFees: '保存支付手续费',
      wechat: '微信支付',
      alipay: '支付宝',
      bank: '银行卡',
      cash: '现金',
      selectPaymentMethod: '选择支付方式',
      feeRateLabel: '手续费率',
      bearerLabel: '承担方',
      bearerRatioLabel: '承担比例',
      bearerRatioLabel: '承担比例',
      feeNameRequired: '请选择费用项目',
      amountRequired: '请输入金额/比例',
      startMonthRequired: '请选择起始月份',
      editFeeItem: '编辑费用项目',
      newFeeItem: '新增费用项目',
      feeItemPlaceholder: '请选择费用项目',
      promotionFee: '推广费',
      posFee: 'POS使用费',
      operationManagementFee: '运营管理费',
      propertyManagementFee: '物业管理费',
      adFee: '广告位使用费',
      other: '其他',
      selectChargeMethod: '请选择',
      amountPlaceholder: '请输入金额或比例',
      selectChargePeriod: '请选择',
      endMonthPlaceholder: '不填则到合同结束',

      // 合同约定
      specialTerms: '特殊条款',
      specialTermsPlaceholder: '请输入特殊条款',
      attachments: '合同附件',
      attachment: '附件',
      uploadAttachment: '上传附件',
      uploadTip: '支持常见文档和图片格式，单文件不超过20MB，最多10个附件',
      noAttachment: '暂无附件',
      uploadSuccess: '{name} 上传成功',
      uploadFailed: '{name} 上传失败',
      fileSizeLimit: '文件大小不能超过20MB',
      fileCountLimit: '最多上传10个附件',
      remark: '备注',
      remarkPlaceholder: '请输入备注',

      // 结算设置（在结算标准Tab中）
      settlementDay: '每月结算日',
      dayUnit: '{n}日',
      monthEnd: '月末',
      advanceSettlementDay: '提前结算日',
      advanceSettlementDayPlaceholder: '选择提前结算日',
      feeBearerLabel: '手续费承担方',

      // 确认消息
      submitConfirm: '确认提交审批？提交后合同信息将不可修改。',
      withdrawConfirm: '确认撤回该合同的审批申请？',
      deleteConfirm: '确认删除合同「{no}」吗？',
      renewConfirm: '确认为合同「{no}」创建续签合同？',
      changeConfirm: '确认为合同「{no}」创建变更合同？',
      terminateTitle: '终止合同',
      terminateReason: '终止原因',
      terminateReasonRequired: '终止原因不能为空',
      terminateReasonPlaceholder: '请输入终止原因...',
      terminateConfirm: '确定终止',

      // 成功消息
      submitSuccess: '提交审批成功',
      withdrawSuccess: '撤回成功',
      deleteSuccess: '删除成功',
      renewSuccess: '续签合同已创建',
      changeSuccess: '变更合同已创建',
      terminateSuccess: '合同已终止',
      saveSuccess: '保存成功',
      loadDetailFailed: '获取合同详情失败',
      generateSuccess: '结算单生成成功',
      generateFailed: '生成失败',
      generateMonthly: '生成结算单',
      selectMonth: '选择月份',
      monthRequired: '请选择结算月份',
    },

    settlement: {
      title: '联营结算单',
      settlementNo: '结算单号',
      settlementMonth: '结算月份',
      merchantName: '商户名称',
      shopNames: '铺位',
      totalSales: '总销售额',
      appliedRate: '应用扣率',
      guaranteeAmount: '保底金额',
      guaranteeMet: '达成保底',
      guaranteeMetYes: '达成',
      guaranteeMetNo: '未达成',
      totalCommission: '总分成',
      payableAmount: '应付金额',
      status: '状态',
      statusDraft: '草稿',
      statusConfirmed: '已确认',
      statusSettled: '已清算',
      statusPaid: '已支付',
      generateMonthly: '生成月度结算单',
      inputSales: '录入销售数据',
      detail: '详情',
      confirm: '确认',
      settle: '清算',
      pay: '支付',
      selectMonth: '选择月份',
      selectContract: '选择合同',
      allContracts: '全部合同（不选则生成所有）',

      // 详情
      detailTitle: '结算单详情',
      contractNo: '合同编号',
      createTime: '创建时间',
      payTime: '支付时间',
      salesDetail: '销售数据明细',
      paymentMethod: '支付方式',
      salesAmount: '销售金额',
      salesRatio: '占比',
      feeRate: '手续费率',
      feeAmount: '手续费',
      netSales: '净销售额',
      total: '合计',
      calcTitle: '分成计算',
      guaranteeSales: '保底销售',
      actualSales: '实际销售',
      isMet: '是否达标',
      metYes: '✓ 是',
      metNo: '✗ 否',
      metFormula: '实际销售 ≥ 保底销售',
      baseCommission: '保底分成',
      excessSales: '超额销售',
      excessRate: '超额扣率',
      excessCommission: '超额分成',
      totalCommissionLabel: '总分成',
      feeDeduction: '手续费扣除',
      adjustAmount: '调整金额',
      adjustRemark: '调整备注',
      adjustReason: '人工调整',
      payableMerchant: '应付商户',
      formulaBase: '总分成 - 手续费 + 调整',
      settleAction: '清算操作',
      adjustAmountLabel: '调整金额',
      adjustRemarkLabel: '调整备注',
      adjustRemarkPlaceholder: '输入调整原因',
      confirmPay: '确认支付',
      paymentVoucher: '支付凭证',
      paymentVoucherRequired: '请输入支付凭证',
      paymentVoucherPlaceholder: '请输入支付凭证号或备注',
      confirmPaySuccess: '支付确认成功',
      payFailed: '支付确认失败',
      close: '关闭',
      executeSettle: '执行清算',
      settleSuccess: '清算成功',
      settleFailed: '清算失败',
      confirmSuccess: '确认成功',
      confirmFailed: '确认失败',
      confirmHint: '确认该结算单吗？确认后可进行清算操作。',
      confirmTitle: '确认提示',
      settleHint: '执行清算操作？清算后将计算最终应付金额。',
      settleTitle: '清算提示',
      loadDetailFailed: '获取结算单详情失败',
      salesShortfall: '销售差额',

      // 销售录入
      inputSalesTitle: '录入销售数据',
      selectContract: '选择合同',
      contractRequired: '请选择合同',
      yearMonth: '年月',
      yearMonthRequired: '请选择月份',
      cashSales: '现金销售',
      wechatSales: '微信销售',
      alipaySales: '支付宝销售',
      bankSales: '银行卡销售',
      otherSales: '其他销售',
      totalSalesLabel: '总销售额',
      inputSuccess: '销售数据录入成功',
      inputFailed: '录入失败',
      remarkLabel: '备注',
      remarkPlaceholder: '备注信息',
      submit: '提交',

      // 列表页扩展字段
      totalSalesAmount: '总销售额',
      guaranteeMetYes: '达成',
      guaranteeMetNo: '未达成',
      monthRequired: '请选择结算月份',
      generateSuccess: '结算单生成成功',
      generateFailed: '生成失败',

      // 新增：商品明细
      productSalesDetail: '商品销售明细',
      productCode: '商品编码',
      productName: '商品名称',
      salesDept: '销售部门',
      salesQuantity: '数量',
      salesAmountLabel: '销售额',
      discountAmount: '折扣金额',
      couponAmount: '用券金额',
      commissionRate: '扣率(%)',
      taxedSettlement: '含税结算额',
      taxRate: '税率(%)',
      taxAmount: '税金',
      untaxedSettlement: '去税结算额',

      // 新增：费用明细
      feeDetail: '费用明细',
      feeItemName: '费用名称',
      feeAttribute: '费用属性',
      feeAttributeCost: '记成本',
      feeAttributeFee: '记费用',
      collectionMethod: '收款方式',
      collectionMethodDeduct: '账扣',
      collectionMethodCash: '现金',
      feeAmountLabel: '费用金额',
      affectsPayable: '影响应付',

      // 新增：金额汇总
      amountSummary: '金额汇总',
      summaryBar: '金额汇总',
      totalGuarantee: '总保底额',
      totalCommissionAmount: '总分成额',
      totalFeeAmount: '总费用额',
      deductFeeAmount: '费用(账扣)',
      cashFeeAmount: '费用(现金)',
      totalPayable: '总应付额',
      merchantInvoiceAmount: '商户应开票',
      mallInvoiceAmount: '商场应开票',
      cashPaymentTotal: '现金缴纳',
      noProductData: '暂无商品销售明细',
      noFeeData: '暂无费用明细',
      basicInfo: '基本信息',
      print: '打印',
      settlementPeriod: '结算周期',
    }
  }
}
